/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminActionLogDto } from '../../models/admin-action-log-dto';
import { CreateAdminActionLogDto } from '../../models/create-admin-action-log-dto';

export interface AdminActionLogControllerCreate$Params {
      body: CreateAdminActionLogDto
}

export function adminActionLogControllerCreate(http: HttpClient, rootUrl: string, params: AdminActionLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminActionLogDto>> {
  const rb = new RequestBuilder(rootUrl, adminActionLogControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminActionLogDto>;
    })
  );
}

adminActionLogControllerCreate.PATH = '/api/admin-action-log';
